var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile-sidebar kt-portlet kt-portlet--bordered"},[(_vm.user.is_uploader)?_c('uploader-card',{attrs:{"user":_vm.user,"active-user":_vm.auth_user,"sidebar":true}}):_c('user-card',{attrs:{"user":_vm.user,"auth-user":_vm.auth_user,"sidebar":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }